import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';

    var InstantWinRule = GenericModel.extend({
        defaults: {
            count: 100,
            message: null
        }
    });
    var RulesCollection = Backbone.Collection.extend({
        model: InstantWinRule,
        initialize: function() {
            var self= this;
            self.on('sync', function(){
               self.each(function(iwr){
                   iwr.changed={};
               });
            });
        }
    });
    export default GenericModel.extend({
        defaults: {
            expiredTitleText: "",
            expiredPageText: "",
            expiredFooterText: "",
            endTitleTextWinner: "",
            endPageTextWinner: "",
            endFooterTextWinner: "",
            endTitleTextLoser: "",
            endPageTextLoser: "",
            endFooterTextLoser: "",
            winRulesList: new RulesCollection(),
            rulesFootnote: "",
            type: "USER_PERCENTAGE"
        },
        model: {
            winRulesList: RulesCollection
        },
        parse: function (response) {
            _.keys(this.model).forEach(key => {
                var embeddedClass = this.model[key];
                var embeddedData = response[key];
                response[key] = new embeddedClass(embeddedData, {parse: true});
            });
            return response;
        },
        initialize() {
            var self = this;
            self.get('winRulesList').on('change', function (model) {
                var index = self.get('winRulesList').indexOf(model);
                _.forEach(model.changed, function (val, key) {
                    self.changed[`winRulesList[${index}].${key}`] = val;
                });
                self.trigger('change', self);
            });
            self.on('sync', function (e) {
                self.get('winRulesList').trigger('sync', e);
                self.changed = {};
            });
        }
    });
